/* eslint-disable camelcase */

import { makeAutoObservable, set, toJS } from 'mobx'
import RolesAction from './RolesAction'

class Role {
  static ROLE_ACTION_ORDER = ['calendars', 'clients', 'events', 'archives', 'users', 'emails', 'roles']

  id = 0
  deletable = true
  editable = true
  name = ''
  roles_actions = []

  _fieldToSave = [
    'id',
    'deletable',
    'editable',
    'name',
    'roles_actions'
  ]

  constructor (data) {
    makeAutoObservable(this)
    if (data) {
      if (data.roles_actions) {
        const missingController = Role.ROLE_ACTION_ORDER
        let isAdmin = false
        for (const rolesAction of data.roles_actions) {
          if (rolesAction.controller === '*') {
            isAdmin = true
          }
          missingController.splice(missingController.indexOf(rolesAction.controller), 1)
          this.roles_actions.push(new RolesAction(rolesAction))
          delete data.roles_actions
        }
        if (missingController.length && !isAdmin) {
          this._createDefaultRoles(missingController)
        }
        this.sortRoleActions()
      } else {
        this._createDefaultRoles()
      }
      set(this, data)
    }
  }

  sortRoleActions () {
    this.roles_actions.sort((a, b) => Role.ROLE_ACTION_ORDER.indexOf(a.controller) - Role.ROLE_ACTION_ORDER.indexOf(b.controller))
  }

  toJson () {
    const role = {}
    for (const props of this._fieldToSave) {
      if (typeof this[props] === 'object') {
        if (typeof this[props].toJson === 'function') {
          role[props] = this[props].toJson()
          continue
        }
      }
      role[props] = toJS(this[props])
    }
    return role
  }

  _createDefaultRoles (missingRoles = Role.ROLE_ACTION_ORDER) {
    for (const controller of missingRoles) {
      this.roles_actions.push(new RolesAction({ controller }))
    }
  }
}

export default Role
